import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { useState } from 'react';
import ProductNavigator from '../components/editors/ProductNavigator';
import { Product } from '../models/Product';
import ProductFamilyTree, { ProductFamilyTreeSelectedItemInfo } from '../components/editors/ProductFamilyTree';
import ProductAttributeList from '../components/editors/ProductAttributeList';

function ProductAttributesPage() {

    const [selectionInfo, setSelectionInfo] = useState<ProductFamilyTreeSelectedItemInfo>();
    

    return <Container>
        <Row>
            <Col>
                <ProductFamilyTree onSelectedChanged={setSelectionInfo} />
            </Col>
        </Row>    
        <Row>
            <Col>
                {selectionInfo && selectionInfo.product && selectionInfo.product.EmProductId && <ProductAttributeList
                    fullProductName={selectionInfo.fullName}
                    productId={selectionInfo.product.EmProductId}/*"25307F43-A224-4736-9F1A-6DA05514F09D"*/
                />}
            </Col>
        </Row>
    </Container>
}

export default connect()(ProductAttributesPage);
